import React from "react";
import ModalUI from "../ui/ModalUI";
import CustomButton from "../CustomButton";
import { Button,OverlayTrigger, Tooltip  } from "react-bootstrap";
import { FaPencilAlt } from "react-icons/fa";
import DeleteIcon from "../Inputs/DeleteIcon";
import styles from "./SelectTemplateModalUI.module.css";


const SelectTemplateModalUI = ({
  show,
  handleClose,
  title = "Select Template",
  items = [], // items is an array of objects that will be displayed in the list
  selectedItem,
  setSelectedItem,
  handleEdit,
  handleDelete,
  handleAddNew,
  handleUse  // handleUse is a function that will be called when the user clicks the "Use" button
}) => {

  const capitalize = (text) => {
  if (!text || typeof text !== "string") return "";
  return text.charAt(0).toUpperCase() + text.slice(1);
   };
  return (
    <ModalUI show={show} handleClose={handleClose} title={title} >
      
    <div className={styles.templateList}>
        {items.map((item) => (
          <div key={item.id} className="d-flex justify-content-between align-items-center p-1  ">
            <div className="form-check gap-2 d-flex align-items-center mb-0">
            <input
                type="radio"
                className="form-check-input border-primary"
                style={{ width: "1.3rem", height: "1.3rem" }}
                value={item.id}
                checked={selectedItem === item.id}
                onChange={() => setSelectedItem(item.id)}
                id={`radio-${item.id}`}
            />
            <label className="form-check-label p-2 text-truncate" 
             style={{ maxWidth: "300px", overflow: "hidden", whiteSpace: "nowrap",cursor:"pointer" }}  htmlFor={`radio-${item.id}`}>
                {capitalize(item.title)}
            </label>
            </div>
            
            <div className="d-flex gap-2">
              <Button
                variant="outline-secondary"
                className="rounded-circle d-flex align-items-center justify-content-center p-2"
                onClick={() => handleEdit(item)}
                style={{ borderColor: "#bcecf3", color: "#1ecae0", background: "transparent" }}
              >
                <FaPencilAlt />
              </Button>
              <DeleteIcon onDelete={() => handleDelete(item.id)} />
            </div>
          </div>
        ))}
      
      </div>

      <div className="d-flex justify-content-end gap-2 mt-4">
        <CustomButton type="button" onClick={handleAddNew}>
          + Add New
        </CustomButton>

        {!selectedItem && (
                <OverlayTrigger
                    placement="top"
                    overlay={
                    <Tooltip id="use-tooltip">
                        Please select a template to use.
                    </Tooltip>
                    }
                >
                    <div>
                    <CustomButton
                        type="button"
                        onClick={() => {
                        const item = items.find((t) => t.id === selectedItem);
                        if (item) {
                            handleUse(item);
                        }
                        }}
                        disabled={!selectedItem}
                    >
                        Use
                    </CustomButton>
                    </div>
                </OverlayTrigger>
                )}
                {selectedItem && (
                <CustomButton
                    type="button"
                    onClick={() => {
                    const item = items.find((t) => t.id === selectedItem);
                    if (item) {
                        handleUse(item);
                    }
                    }}
                >
                    Use
                </CustomButton>
                )}

      </div>
    </ModalUI>
  );
};

export default SelectTemplateModalUI;
